import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import vuetify from '@/config/vuetify'
import helper from '@/config/helper.js'
import directive from '@/config/directive.js'
import i18n from '@/config/i18n.js'

import Moment from 'moment'
import VueToast from 'vue-toast-notification';
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import axios from 'axios'
import * as Cookies from 'tiny-cookie'
import creditCardType from "credit-card-type";

import '@fontsource-variable/montserrat';
import '@fontsource-variable/nunito-sans';
import '@mdi/font/css/materialdesignicons.css';
import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast);
Vue.use(VueTheMask);

Vue.prototype.$creditCardType = creditCardType
Vue.prototype.moment = Moment
Vue.use(money, {
	precision: 2,
	decimal: ',',
	thousands: '.',
	prefix: 'R$ ',
	masked: false
})

Vue.use(directive);
Vue.directive('date_format', directive.date_format);
Vue.directive('timestamp_format', directive.timestamp_format);
Vue.directive('value_format', directive.value_format);


Vue.use({
	install(){
		Vue.helper = helper;
		Vue.prototype.$helper = helper;

		Vue.cookie = Cookies;
		Vue.prototype.$cookie = Cookies;
	}
});

/**
 * Number.prototype.format(n, x, s, c)
 * 
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
 Number.prototype.format = function(n, x, s, c) {
	var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
		num = this.toFixed(Math.max(0, ~~n));

	return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};



/********************/
/* 	  LINGUAGEM 	*/
/********************/

const loadedLanguages = ['en', 'pt'] // our default language that is prelaoded 

function setI18nLanguage(lang){
	i18n.locale = lang
	axios.defaults.headers.common['Accept-Language'] = lang
	document.querySelector('html').setAttribute('lang', lang)
	return lang
}

export function loadLanguageAsync(lang){

	if(i18n.locale !== lang){

		if(lang == 'en'){
			locale.use(enLang);
		}else if(lang == 'pt'){
			locale.use(ptLang);
		}

		if(!loadedLanguages.includes(lang)){
			return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}`).then(msgs => {
				i18n.setLocaleMessage(lang, msgs.default)
				loadedLanguages.push(lang)
				return setI18nLanguage(lang)
			})
		}

		return Promise.resolve(setI18nLanguage(lang))
	}
	return Promise.resolve(lang)
}


Vue.prototype.$locale = {
	change (lang) {
		Vue.config.lang = lang;
		loadLanguageAsync(lang);
	},
	current () {
		return Vue.config.lang
	}
}


/********************/
/* 	  CONSTRUTOR 	*/
/********************/
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app")
